import React from 'react';
import { Showcase } from '../showcase-ui/components/Showcase.tsx';
import { content } from '../showcase/showcase.content.js';

export default function ShowcasePage() {
  // MainLayout adds padding + top offset; the showcase wants a full-bleed canvas.
  return (
    <div style={{ margin: -24, marginTop: -64 }}>
      <Showcase content={content} appKey="doc-authoring" />
    </div>
  );
}

